import {
  Card,
  createStyles,
  Grid,
  Group,
  Image,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";

const useStyles = createStyles((theme) => ({
  root: {
    padding: theme.spacing.lg,
  },
  label: {
    color: theme.colors.gray[6],
    fontSize: 14,
  },
  value: {
    fontWeight: 500,
    fontSize: 16,
  },
  ownerLabel: {
    color: theme.colors.gray[6],
    fontSize: 12,
  },
  ownerValue: {
    fontWeight: 500,
    fontSize: 14,
  },
  sectionTitle: {
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.xs,
    fontSize: 18,
    fontWeight: 600,
    color: theme.colors.dark[7],
  },
  ownerSectionTitle: {
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.xs,
    fontSize: 16,
    fontWeight: 600,
    color: theme.colors.dark[7],
  },
  image: {
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
    width: "100%",
    height: "auto",
    maxHeight: 200,
    objectFit: "cover",
  },
  card: {
    backgroundColor: theme.colors.gray[0],
    padding: theme.spacing.sm,
  },
  ownerCard: {
    backgroundColor: theme.colors.gray[0],
    padding: theme.spacing.sm,
  },
}));

export default function SupplierDetailModal({ data }) {
  const { height } = useViewportSize();
  const { classes } = useStyles();

  if (!data) return <Text align="center">No supplier data available</Text>;

  return (
    <ScrollArea style={{ height: height / 1.6 }}>
      <div className={classes.root}>
        <Grid gutter="lg">
          <Grid.Col span={12}>
            <Grid gutter="lg">
              <Grid.Col span={6}>
                <Card shadow="sm" withBorder className={classes.card}>
                  <Text className={classes.sectionTitle}>Business Detail</Text>
                  <Grid gutter="lg">
                    <Grid.Col span={4}>
                      <Stack spacing="xs">
                        <Group spacing="sm">
                          <Text className={classes.label}>Supplier Code:</Text>
                          <Text className={classes.value}>
                            {data.supplier_code}
                          </Text>
                        </Group>
                        <Group spacing="sm">
                          <Text className={classes.label}>Business Type:</Text>
                          <Text className={classes.value}>
                            {data.business_type
                              ? data.business_type.charAt(0).toUpperCase() +
                                data.business_type.slice(1).toLowerCase()
                              : ""}
                          </Text>
                        </Group>
                      </Stack>
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Stack spacing="xs">
                        <Group spacing="sm">
                          <Text className={classes.label}>Region:</Text>
                          <Text className={classes.value}>
                            {data.business_region?.name}
                          </Text>
                        </Group>
                        <Group spacing="sm">
                          <Text className={classes.label}>Zone:</Text>
                          <Text className={classes.value}>
                            {data.business_zone}
                          </Text>
                        </Group>
                      </Stack>
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Stack spacing="xs">
                        <Group spacing="sm">
                          <Text className={classes.label}>Woreda:</Text>
                          <Text className={classes.value}>
                            {data.business_woreda}
                          </Text>
                        </Group>
                        <Group spacing="sm">
                          <Text className={classes.label}>Kebele:</Text>
                          <Text className={classes.value}>
                            {data.business_kebele}
                          </Text>
                        </Group>
                      </Stack>
                    </Grid.Col>
                  </Grid>
                </Card>
              </Grid.Col>

              <Grid.Col span={6}>
                <Card shadow="sm" withBorder className={classes.ownerCard}>
                  <Text className={classes.ownerSectionTitle}>
                    Owner Information
                  </Text>
                  <Grid gutter="lg">
                    <Grid.Col span={6}>
                      <Stack spacing="xs">
                        <Group spacing="sm">
                          <Text className={classes.ownerLabel}>Full Name:</Text>
                          <Text className={classes.ownerValue}>
                            {`${data.owner_firstname} ${data.owner_middlename} ${data.owner_lastname}`}
                          </Text>
                        </Group>
                        <Group spacing="sm">
                          <Text className={classes.ownerLabel}>Phone:</Text>
                          <Text className={classes.ownerValue}>
                            {data.owner_phone_number}
                          </Text>
                        </Group>
                      </Stack>
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <Stack spacing="xs">
                        <Group spacing="sm">
                          <Text className={classes.ownerLabel}>ID Type:</Text>
                          <Text className={classes.ownerValue}>
                            {data.owner_id_type}
                          </Text>
                        </Group>
                      </Stack>
                    </Grid.Col>
                  </Grid>
                </Card>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={12}>
            <Text className={classes.sectionTitle}>Documents</Text>
            <Grid gutter="md">
              <Grid.Col span={4}>
                <Card shadow="sm" withBorder>
                  <Text className={classes.label}>Owner ID</Text>
                  <Image
                    src={data.owner_id_url}
                    alt="Owner ID"
                    className={classes.image}
                    withPlaceholder
                    placeholder={<Text align="center">No image found</Text>}
                  />
                </Card>
              </Grid.Col>
              <Grid.Col span={4}>
                <Card shadow="sm" withBorder>
                  <Text className={classes.label}>Trade License</Text>
                  <Image
                    src={data.trade_license_document_url}
                    alt="Trade License"
                    className={classes.image}
                    withPlaceholder
                    placeholder={<Text align="center">No image found</Text>}
                  />
                </Card>
              </Grid.Col>
              <Grid.Col span={4}>
                <Card shadow="sm" withBorder>
                  <Text className={classes.label}>TIN Certificate</Text>
                  <Image
                    src={data.tin_certification_document_url}
                    alt="TIN Certificate"
                    className={classes.image}
                    withPlaceholder
                    placeholder={<Text align="center">No image found</Text>}
                  />
                </Card>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
    </ScrollArea>
  );
}
